export const apiConstants = {
  roles: "/api/role",
  permissions: "/api/role/permissions"
};
